<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0 font-size-18">{{ title }}</h4>
      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          @for(item of breadcrumbItems;track $index){
          <li class="breadcrumb-item" [ngClass]="{'active': item.active == true}">
            @if(item.active){
            {{ item.label }}
            }@else {
            <a href="javascript: void(0);">{{ item.label }}</a>
            }
          </li>
          }
        </ol>
      </div>
    </div>
  </div>
</div>